import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedSection from './components/FeaturedSection';
import FeaturesSection from './components/FeaturesSection';
import ArticleSection from './components/ArticleSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  const homepageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '芒果视频',
    url: 'https://www.mangoshipin.com/',
    description: '芒果视频作为蜜桃视频、糖豆视频之外的优质推荐，资源丰富播放流畅。对比蘑菇视频、蓝莓视频，芒果视频App好用且免费高清，值得选择的视频平台。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.mangoshipin.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '芒果视频',
    url: 'https://www.mangoshipin.com/',
    description: '优质视频平台，提供免费高清在线观影服务',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      { '@type': 'Question', name: '芒果视频好用吗？和其他平台相比有什么优势？', acceptedAnswer: { '@type': 'Answer', text: '芒果视频作为新兴视频平台，资源丰富且更新速度快。相比蜜桃视频、糖豆视频等同类平台，芒果视频在播放流畅度、画质清晰度和界面友好度方面都有明显优势。' } },
      { '@type': 'Question', name: '芒果视频的资源丰富吗？有没有最新电影和电视剧？', acceptedAnswer: { '@type': 'Answer', text: '芒果视频拥有超过5万部影视资源，涵盖电影、电视剧、综艺、动漫、纪录片、体育、音乐、教育等八大类别。' } },
      { '@type': 'Question', name: '芒果视频App是免费的吗？需要会员吗？', acceptedAnswer: { '@type': 'Answer', text: '芒果视频App提供免费和会员两种观看模式。免费用户即可观看绝大部分内容，支持高清画质。' } },
      { '@type': 'Question', name: '芒果视频支持哪些设备？可以在电视上看吗？', acceptedAnswer: { '@type': 'Answer', text: '芒果视频支持多平台多设备使用，包括手机、平板电脑、电脑网页端以及智能电视。' } },
      { '@type': 'Question', name: '芒果视频的播放流畅度怎么样？会不会卡顿？', acceptedAnswer: { '@type': 'Answer', text: '芒果视频采用了先进的CDN加速技术和智能码率调节算法，能够根据用户的网络状况自动调整画质，确保播放流畅不卡顿。' } },
      { '@type': 'Question', name: '芒果视频和蜜桃视频、糖豆视频有什么不同？', acceptedAnswer: { '@type': 'Answer', text: '芒果视频与蜜桃视频、糖豆视频虽然都是视频平台，但定位各有侧重。芒果视频主打综合视频资源和极致播放体验，资源覆盖面更广。' } },
    ],
  };

  return (
    <>
      <ScrollToTop />
      <SEOHead
        schema={{ ...homepageSchema, ...orgSchema, ...faqSchema }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedSection />
        <FeaturesSection />
        <ArticleSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}